import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLock = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-224.00 -348.44 1600.00 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M320 768H832V960Q832 1066 757.0 1141.0Q682 1216 576.0 1216.0Q470 1216 395.0 1141.0Q320 1066 320 960ZM1152 672V96Q1152 56 1124.0 28.0Q1096 0 1056 0H96Q56 0 28.0 28.0Q0 56 0 96V672Q0 712 28.0 740.0Q56 768 96 768H128V960Q128 1144 260.0 1276.0Q392 1408 576.0 1408.0Q760 1408 892.0 1276.0Q1024 1144 1024 960V768H1056Q1096 768 1124.0 740.0Q1152 712 1152 672Z"
	})
});
export default SvgLock;
